import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-footer_desktopapp_modalandroid_dismiss-click';
/**
 * Dismiss modal (Android)
 */
export function trackRetailerMobileFooterDesktopappModalandroidDismissClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
